<div class="popup-wrap">
    <div class="popup-header" fxLayout="row" fxLayoutAlign="space-between center">
        <h5>Invite Members to join workspace</h5>
        <svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer" (click)="onNoClick()"
            xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
            <defs>
                <path id="gajl1bvf2a"
                    d="M9.502 7.51c-.27.27-.262.717 0 .98l5.008 5.008c.27.27.275.704-.005.984l-.023.024c-.273.273-.722.267-.985.004L8.49 9.502c-.27-.27-.717-.262-.98 0L2.502 14.51c-.27.27-.704.275-.984-.004l-.024-.024c-.273-.273-.267-.722-.004-.984L6.497 8.49c.27-.27.263-.717 0-.98L1.49 2.502c-.27-.27-.275-.704.004-.984l.024-.024c.273-.273.722-.267.984-.004L7.51 6.498c.27.27.717.262.98 0l5.007-5.008c.27-.27.705-.275.985.004l.023.024c.274.273.268.722.005.984L9.502 7.51z" />
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g transform="translate(-1 -1)">
                    <use fill="#000" xlink:href="#gajl1bvf2a" />
                </g>
            </g>
        </svg>
    </div>



    <div class="popup-content">
        <div class="input-container">
            <label for="" class="paragraph semi-bold">Enter email address</label>
            <div class="chip-input m-t-10">
                <mat-form-field class="chip-list p-0">
                    <mat-chip-listbox class="chip-wrapper" #chipList aria-label="">
                        <mat-chip-option [class.error-clr]="(email.invalid)?'error-clr':''" *ngFor="let email of emails"
                            [selectable]="selectable" [removable]="removable" (removed)="remove(email)">
                            {{email.name}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip-option>

                        <input class="" [matChipInputFor]="chipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="add($event)">
                    </mat-chip-listbox>
                </mat-form-field>
            </div>
        </div>
        <div class="btn-wrap">
            <button mat-button class="btn-primary m-r-8" fxFlex="88px" (click)="saveData()"
                [disabled]="emails.length==0 || sendBtnDisable">
                <ng-container *ngIf="btnLoader;else textTemp">
                    <mat-spinner [diameter]=20></mat-spinner>
                </ng-container>
                <ng-template #textTemp> Send Link </ng-template>

            </button>
            <button mat-button class="btn-tertiary" (click)="onNoClick()">Cancel</button>
        </div>
    </div>

    <div class="footer">
        <p class="txt-12" fxLayout="row" fxLayoutAlign="flex-start center">
            <span class="m-r-4">or share the workspace via</span>
             <a class="url-link relative m-r-4" href="javascript:void(0)"
                (click)="getShareLink()">link
                <span class="tooltip-bx" fxLayoutAlign="start center">
                    <span class="pointer d-block"></span>
                    <span>Copy to Clipboard</span>
                </span>
            </a>
            <mat-spinner *ngIf="linkLoader" [diameter]=20></mat-spinner>
        </p>
    </div>
</div>
